import { useCallback, useEffect } from 'react'
import { useMutation, useReactiveVar } from '@apollo/client'
import { useWallet } from '@solana/wallet-adapter-react'
import { LOG_OUT } from 'api/auth/logout'
import { clearSolanaWalletSession } from 'features/auth/utils/clear-solana-wallet-session'
import { userVar } from 'shared/store/user'

export const useVerifyUserSolana = () => {
  const [commitLogout] = useMutation(LOG_OUT)
  const { disconnect, publicKey } = useWallet()
  const user = useReactiveVar(userVar)
  const currentAccountAddress = publicKey?.toBase58()

  const handleLogOut = useCallback(async () => {
    await disconnect()
    clearSolanaWalletSession()
    await commitLogout()
    window.location.reload()
  }, [commitLogout, disconnect])

  useEffect(() => {
    if (!user || !commitLogout || !currentAccountAddress) return

    const isAccountAddressRegistered =
      user.wallet?.address === currentAccountAddress

    if (isAccountAddressRegistered) return

    handleLogOut()
  }, [commitLogout, user, handleLogOut, currentAccountAddress])
}
